import React from 'react';
import {useState, useEffect} from 'react';
import Echo from 'laravel-echo';
import Pusher from 'pusher-js';
import config from 'config';
import {ChatMessage} from '../../../FW/Models/ChatMessage';
import './Chat.scss';
import _ from 'underscore';
import Loading from '../../../CommonElements/Loading';
import ChatMessagesView from './ChatMessages';
import {v1 as uuid} from 'uuid';
import { GoogleReCaptchaProvider, withGoogleReCaptcha } from 'react-google-recaptcha-v3';
global.Pusher = Pusher;

const MyEcho = new Echo({
  broadcaster: 'pusher',
  key: config.PUSHER_APP_KEY,
  wsHost: config.WEBSOCKET_HOST,
  wsPort: 6001,
  wssPort: 6001,
  namespace: 'Finalweb\\Events',
  enabledTransports: ['ws', 'wss'],
  encrypted: true
});

const Chat = function(props){
  const [user, setUser] = useState(null);
  const [message, setMessage] = useState('');
  const [messages, setMessages] = useState([]);
  const [username, setUsername] = useState('');
  const [loading, setLoading] = useState(true);
  const [reload, setReload] = useState(1);

  const setLocalStorage = (key, value) => {
    return localStorage.setItem('chat-' + props.section.get('relatable_id') + '-' + key, value);
  };

  const getLocalStorage = (key) => {
    return localStorage.getItem('chat-' + props.section.get('relatable_id') + '-' + key);
  };

  useEffect(() => {
    if (FW.store.get('user')) {
      setUser({
        id: FW.store.get('user').get('id'),
        name: FW.store.get('user').get('name')
      });
    } else if (getLocalStorage('user_id')) {
      setUser({
        id: getLocalStorage('user_id'),
        name: getLocalStorage('user_name')
      })
    }
    props.section._editButtons = [
      {
        title: 'Clear Messages',
        class: 'glyphicon-trash',
        type: 'btn-default',
        action: () => {
          swal.fire({
            icon: 'question',
            text: 'Are you sure you would like to clear all the messages in this chat?',
            title: 'Clear Messages',
            showCancelButton: true
          }).then((r) => {
            if (r.value) {
              $.ajax({
                type: 'DELETE',
                url: props.section.get('messages').url
              });
            }
          });
        }
      }
    ];
  }, []);

  const sectionId = props.section.get('relatable_id');
  useEffect(() => {
    props.section.get('messages').sortField = 'id';
    props.section.get('messages').sortOrder = 'DESC';
    props.section.get('messages').fetch().then(() => {
      props.section.get('messages').sortOrder = 'ASC';
      props.section.get('messages').sort();
      setLoading(false);
      setMessages(props.section.get('messages').toJSON());
    });
  }, [reload]);

  const audioRef = React.createRef();

  useEffect(() => {
    if (user) {
      MyEcho.channel('chat-' + sectionId).listen('MessagePosted', (e) => {
        setMessages((ms) => {
          ms = _.clone(ms);
          ms.push(e.message);
          //document.getElementById('chat-sounds-' + props.section.get('id')).play();
          return ms;
        });
      }).listen('ChatUserBanned', () => {
        setReload(reload + 1);
      });
    }
  }, [user]);

  const sendMessage = () => {
    if (!user) {
      return;
    }
    if (message !== '') {
      let m = ChatMessage.findOrCreate({
        message: message,
        user_id: user.id,
        user_name: user.name,
        relatable_id: props.section.get('relatable_id')
      });
      m.save({}, {
        success: (e) => {
          setMessages(ms => {
            ms = _.clone(messages);
            ms.push(m.toJSON());
            return ms;
          });
          setMessage('');
        }
      });
    }
  };

  const setMessageEvent = (e) => {
    setMessage(e.target.value);
  };

  const keyPressed = (e) => {
    if (e.key === 'Enter') {
      sendMessage();
    }
  };

  const usernameChanged = (e) => {
    setUsername(e.target.value);
  };

  const login = async () => {
    let token = await props.googleReCaptchaProps.executeRecaptcha('chat_login');
    $.post(config.API_ROOT + '/chat-messages/validate-token', {
      token: token
    }).then((d) => {
      if (d.success) {
        let id = uuid();
        setLocalStorage('user_id', id);
        setLocalStorage('user_name', username);
        setUser({
          id: id,
          name: username
        });
      }
    });
  };

  return <div style={{position: 'relatve', height: props.section.prop('height') || 200}}>
    <div className="chat-wrapper">
      {!user ? <div style={{minHeight: props.section.prop('height') || 200, textAlign: 'center', paddingTop: 65}}>
        {props.section.prop('allow_anonymous') ? <div>
          <p>Enter your name to use the live chat feature</p>
          <div style={{width: '80%', maxWidth: 400, margin: 'auto'}}>
            <input onChange={usernameChanged} value={username} placeholder="Display Name" className="form-control" style={{marginBottom: 10}} />
            <span className="btn btn-default" onClick={login}>Start Chatting</span>
          </div>
        </div> : <div>
          <p>Please login to chat.</p>
        </div>}
      </div> : (loading ? <Loading /> : <ChatMessagesView user={user} messages={messages} pageSectionId={props.section.get('id')} />) }

    </div>
    <div className={user ? 'input-group' : 'input-group disabled'}>
      <input className={'form-control ' + (!user ? 'disabled' : '')} value={message} onKeyPress={keyPressed} onChange={setMessageEvent} />
      <div className="input-group-btn">
        <span className={"btn btn-outline btn-primary " + (!user ? 'disabled' : '')} onClick={sendMessage}>Send</span>
      </div>
    </div>
    <audio src="/assets/finalweb/chat-section/message-received.ogg" id={`chat-sounds-` + props.section.get('id')} />
  </div>;
};

let ChatWrapper = withGoogleReCaptcha(Chat);

export default function(props){
  return <GoogleReCaptchaProvider reCaptchaKey={config.RECAPTCHA3_PUBLIC_KEY}>
    <ChatWrapper {...props} />
  </GoogleReCaptchaProvider>;
}
